import React, {useRef, useState} from 'react';
import * as Yup from "yup";
import Switch from "react-bootstrap-switch";
import { useForm } from "react-hook-form";
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';

import { showLoader } from "../../../components/loader/loader";
import { ButtonCancel, ButtonSubmit } from "../../../components/buttons/buttonsActions";
import { RoutScheduleList } from "./_list";
import { routScheduleService } from "../../../jwt/_services/xailing/routScheduleService";
import {REQUIRED} from "../../../components/i18n/i18n";


export default function RoutSchedule(props) {
	// MAIN props
	const [fbDataBaseId] = useState(props?.app?.fbDataBase?.id);
	const [xailingRout] = useState(props.item);
	const [editMode, setEditMode] = useState(false);
	const [itemToEdit, setItemToEdit] = useState();

	const refList = useRef(null);

	// FORM props
	const [loading, setLoading] = useState(false);
	const [status, setStatus] = useState(true);
	const [time12, setTime12] = useState("00:00");
	const [time24, setTime24] = useState("00:00");

	const validationSchema = Yup.object().shape({
		time24: Yup.string().required( REQUIRED )
	});

	const {register, handleSubmit, errors} = useForm({
		validationSchema: validationSchema,
	});

	const setForm = (_editMode, _itemToEdit) => {
		setEditMode(_editMode);
		setItemToEdit(_itemToEdit);

		if (_itemToEdit) {
			setStatus(_itemToEdit.status);
			setSchedule(_itemToEdit.time24);
		} else {
			setStatus(false);
		}
	}

	const onSubmit = (data, _) => {

		const dataRequest = {
			fbDataBase:  { id : fbDataBaseId },
			item:{
				// Strings
				time12: time12,
				time24: time24,
				// Booleans
				status: status,
				// Objects
				xailingRout: { id : xailingRout.id },
			}
		};

		setLoading(true);

		if (!editMode) {
			return routScheduleService.saveItem(dataRequest)
				.then(_ =>resetForm())
				.finally(()=>setLoading(false))
		} else {
			let id = itemToEdit.id;
			dataRequest.item.id = itemToEdit?.id

			return routScheduleService.updateItem(id, dataRequest)
				.then(_ =>resetForm())
				.finally(()=>setLoading(false))
		}
	};

	const onTimeChange = (value) => setSchedule(value);

	const setSchedule = (_time) => {
		const h24 = _time.split(':')[0];
		const m24 = _time.split(':')[1];

		let _time12;

		 if (h24 === "12") {
			_time12 = `${h24}:${m24} PM`;
		} else if (h24 > 12) {
		 	_time12 = `${h24 - 12}:${m24} PM`;
		 } else {
			_time12 = `${h24}:${m24} AM`;
		}

		setTime12(_time12);
		setTime24(_time);
	}

	const resetForm = () => {
		setEditMode(false);
		setItemToEdit(null);
		setStatus(false);
		setSchedule('00:00');
		refList.current.refreshList();
	}

	const closeForm = () => props.setForm(false, null, 'LIST');

	return (
		<>
			{/* --------------------------------------------------------------------------------*/}
			{/* Formulario */}
			{/* --------------------------------------------------------------------------------*/}
			<Row>
				<Col md="12">
					<Card>
						{loading && showLoader()}
						<CardTitle className="bg-light border-bottom p-3 mb-0">
							<i className="fas fa-clock mr-2"/>
							Horarios de la ruta { xailingRout.code  ? " : " + xailingRout.code : "" }
						</CardTitle>
						<CardBody>
							<Form onSubmit={handleSubmit(onSubmit)}>
								<Row>
									<Col md="4">
										<FormGroup>
											<Label >Hora</Label>
											<Input type="time" name="time24"
											       placeholder="Ingrese hora"
											       innerRef={register}
											       value={time24}
											       onChange={e => onTimeChange(e.target.value)}
												   className={(errors.time24 ? ' is-invalid' : '')}
											/>
											{ errors.time24 && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.time24?.message}</div> }
										</FormGroup>
									</Col>
									<Col md="2">
										<FormGroup>
											<Label>Activo</Label>
											<br/>
											<Switch animate={true} offText={"No"} onText={"Si"}
											        value={status}
											        onChange={() => setStatus(!status)}
											/>
										</FormGroup>
									</Col>
									<Col md="2">
										<FormGroup>
											<Label>Hora (12 hrs)</Label>
											<Input type="text"
											       placeholder="00:00"
											       innerRef={register}
											       value={time12}
											       disabled={true}
											/>
										</FormGroup>
									</Col>
									<Col md="2">
										<FormGroup>
											<Label>Hora (24 hrs)</Label>
											<Input type="text"
											       placeholder="00:00"
											       innerRef={register}
											       value={time24}
											       disabled={true}
											/>
										</FormGroup>
									</Col>
								</Row>
								<CardBody className="border-top">
									<div className="float-right">
										<ButtonSubmit/>
										<ButtonCancel onClick={closeForm}/>
									</div>
								</CardBody>
							</Form>
						</CardBody>
					</Card>
				</Col>
			</Row>
			{/* --------------------------------------------------------------------------------*/}
			{/* Listado */}
			{/* --------------------------------------------------------------------------------*/}
			<Row>
				<Col md="12">
					<RoutScheduleList
						setForm={setForm}
						xailingRout={xailingRout}
						ref={refList}
						app={props.app}
					/>
				</Col>
			</Row>
		</>
	);
}